import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Auth } from "aws-amplify";
import { Button, Page, Container, Box } from "@common-ui/ui";
import { Add } from "@mui/icons-material";
import { ToggleViews } from "../../components";
import { Header } from "../../components";
import { getOrgWorkEvents } from "../../services";
import { WorkEventsCardView } from "./WorkEventsCardView";
import { WorkEventsListView } from "./WorkEventsListView";
import { WorkEventsTableView } from "./WorkEventsTableView";
import { RemoveWorkEventDialog } from "./RemoveWorkEventDialog";
import { CreateWorkEventDialog } from "./CreateWorkEventDialog";
import { CustomerPlaceDialog } from "../../components/ScopingHeader/CustomerPlaceDialog";
import { useContext } from "react";
import { ModalContext } from "../../components/BrowserAlert/modalContext";

export const WorkEvents = (props) => {
  let history = useHistory();
  const currentOrg = useSelector(
    (state) => state.organization?.currentOrganization
  );

  let appRole = currentOrg?.app_role;
  let doesUserHavePermission = appRole === "ADMIN" || appRole === "SUPERVISOR";

  const [isLoading, setIsLoading] = useState(false);
  const [view, setView] = useState("table-view");
  const [workEvents, setWorkEvents] = useState([]);
  const [currentOrgId, setCurrentOrgId] = useState("");
  const [currentWorkEventId, setCurrentWorkEventId] = useState("");
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openCustomerPlaceDialog, setOpenCustomerPlaceDialog] = useState(false);
  const [openWorkEventDialog, setOpenWorkEventDialog] = useState(false);
  const [placesParent, setPlacesParent] = useState(undefined);
  const [newPlaceParent, setNewPlaceParent] = useState(undefined);
  const [places, setPlaces] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [newCustomer, setNewCustomer] = useState(null);
  const workEventCount = workEvents?.length || 0;

  let { handleModal } = useContext(ModalContext);

  const handleCloseWorkEventDialog = () => {
    setOpenWorkEventDialog(false);
  };

  const handleCloseCustomerPlaceDialog = () => {
    setOpenCustomerPlaceDialog(false);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  useEffect(() => {
    const getAllWorkEvents = async () => {
      setIsLoading(true);
      try {
        if (currentOrg?.id !== null || currentOrg?.id !== undefined) {
          let workEvents = await getOrgWorkEvents(currentOrg?.id);
          setWorkEvents(workEvents);
          setIsLoading(false);
        }
        // setOrgs(rowsData);
      } catch (error) {
        // alert(error)
        setWorkEvents(error);
        setIsLoading(false);
      }
    };
    getAllWorkEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg]);

  const displayData = () => {
    if (view === "card-view") {
      return <WorkEventsCardView isLoading={isLoading} rowsData={workEvents} />;
    } else if (view === "list-view") {
      return <WorkEventsListView isLoading={isLoading} rowsData={workEvents} />;
    } else {
      return (
        <WorkEventsTableView
          isLoading={isLoading}
          isShowTableHeader={false}
          rowsData={workEvents}
          setCurrentOrgId={setCurrentOrgId}
          setCurrentWorkEventId={setCurrentWorkEventId}
          setOpenRemoveDialog={setOpenRemoveDialog}
        />
      );
    }
  };

  const handleView = (_, newView) => {
    setView(newView);
  };

  return (
    <Page title="FlukeWorks">
      <Header
        xl
        menuBar
        name={`Work Events (${workEventCount})`}
        history={history}
        action={
          doesUserHavePermission ? (
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => setOpenCustomerPlaceDialog(true)}
              style={{ textTransform: "normal !important" }}
            >
              Create Work Event
            </Button>
          ) : (
            ""
          )
        }
      />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Box sx={{ my: 2 }}>
          <ToggleViews view={view} handleView={handleView} />
        </Box>
        {displayData()}
      </Container>
      <CustomerPlaceDialog
        open={openCustomerPlaceDialog}
        handleClose={handleCloseCustomerPlaceDialog}
        currentOrgId={currentOrgId}
        setCustomer={setCustomer}
        setPlaces={setPlaces}
        customer={customer}
        places={places}
        setNewCustomer={setNewCustomer}
        placesParent={placesParent}
        setPlacesParent={setPlacesParent}
        setNewPlaceParent={setNewPlaceParent}
        handleModal={handleModal}
        setIsLoading={setIsLoading}
        setOpenCompleteWorkEventDialog={() => {
          setOpenWorkEventDialog(true);
        }}
      />
      <CreateWorkEventDialog
        open={openWorkEventDialog}
        handleClose={handleCloseWorkEventDialog}
        currentOrgId={currentOrg?.id}
        customer={newCustomer}
        places={newPlaceParent}
        setOpenCustomerPlaceDialog={() => {
          setOpenCustomerPlaceDialog(true);
        }}
      />
      <RemoveWorkEventDialog
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        currentOrgId={currentOrgId?.id}
        currentWorkEventId={currentWorkEventId}
        setWorkEvents={setWorkEvents}
        getOrgWorkEvents={getOrgWorkEvents}
      />
    </Page>
  );
};
